<template>
  <!--
    Witness fields are rendered inline by SignatureView.vue when the user
    checks "signing with an X". This component acts as a placeholder marker
    in preview/readonly mode so admins can see where the fields will show.
  -->
  <div v-if="mode === 'preview'" class="witnesses-view">
    <div v-for="n in component.props?.count || 2" :key="n" class="p-field">
      <label>Witness {{ n }}</label>
      <InputText disabled fluid />
    </div>
  </div>
</template>

<script setup>
import InputText from 'primevue/inputtext'

defineProps({
  component: { type: Object, required: true },
  shareholder: { type: Object, default: () => ({}) },
  mode: { type: String, default: 'vote' },
  form: { type: Object, default: null },
  shareValue: { type: Number, default: 2 },
  ballotComponents: { type: Array, default: () => [] },
})
</script>

<style scoped>
.witnesses-view {
  padding: 10px 0;
  .p-field {
    margin-bottom: 8px;
    label {
      display: block;
      font-size: 0.85rem;
      color: #555;
      margin-bottom: 4px;
    }
  }
}

:deep(.p-inputtext) {
  width: 100%;
}
</style>
